module.exports = __webpack_public_path__ + "static/media/influencer-expanded.b3b1226f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/influencer-expanded.svg
// module id = 1948
// module chunks = 0